import * as React from 'react';
import { Icon } from '../icons.jsx';
import { Badge, Button } from '../ui.jsx';

const ConceptProvider = ({
  name,
  address,
  stars,
  ages,
  state,
  onProfile,
  onPrimary,
}) => {
  const isOpen = state.kind === 'open';
  const isWaitlist = state.kind === 'waitlist';
  return (
    <article className="compass-provider-row">
      <div className="compass-official">
        <span className="compass-source-label">Official provider information</span>
        <h2>{name}</h2>
        <p>{address}</p>
        <div>
          <span><Icon name="shield" size={13}/>Certified provider</span>
          <span><Icon name="star" size={13}/>{stars} Keystone STARS</span>
          <span><Icon name="user" size={13}/>{ages}</span>
        </div>
      </div>

      <div className={`compass-live-state is-${state.kind}`}>
        <span className="compass-source-label">
          {state.kind === 'none' ? 'Provider not participating' : 'Updated by the provider'}
        </span>
        <strong>{state.title}</strong>
        <p>{state.detail}</p>
        {state.updated && <small>{state.updated}</small>}
      </div>

      <div className="compass-actions">
        {state.kind !== 'none' && (
          <Button
            variant={isOpen ? 'primary' : 'secondary'}
            size="sm"
            icon={isOpen ? 'calendar' : isWaitlist ? 'inbox' : undefined}
            onClick={onPrimary}
          >
            {isOpen ? 'Schedule a tour' : 'Join waitlist'}
          </Button>
        )}
        {state.kind !== 'none' ? (
          <Button variant="ghost" size="sm" onClick={onProfile}>
            View enhanced profile
          </Button>
        ) : (
          <Button variant="secondary" size="sm" icon="phone">
            Contact provider
          </Button>
        )}
        {state.kind !== 'none' && <small>Powered by Find My Childcare</small>}
      </div>
    </article>
  );
};

export const CompassConceptScreen = ({ go, onBook, onWaitlist }) => (
  <div className="compass-concept route-in">
    <section className="compass-concept-hero">
      <div className="container">
        <Badge tone="yellow">Discussion concept</Badge>
        <h1>From “call for availability” to a clear next step</h1>
        <p>
          COMPASS keeps the official provider record. Participating providers add current
          openings, waitlists, richer profiles, and family actions through Find My Childcare.
        </p>
        <div className="compass-concept-warning">
          <Icon name="bell" size={17}/>
          <span>This is a Find My Childcare concept for discussion. It is not a live COMPASS page.</span>
        </div>
      </div>
    </section>

    <section className="compass-concept-results">
      <div className="container">
        <div className="compass-results-heading">
          <div>
            <span>Illustrative search results near 19130</span>
            <h2>Three clear provider states</h2>
          </div>
          <div className="compass-key">
            <span><i className="is-official"/>Pennsylvania information</span>
            <span><i className="is-provider"/>Provider updates</span>
          </div>
        </div>

        <div className="compass-provider-list">
          <ConceptProvider
            name="Sunnyside Learning Garden"
            address="2418 Brown Street, Philadelphia, PA"
            stars="4"
            ages="Infant through Pre-K"
            state={{
              kind: 'open',
              title: '3 Pre-K openings',
              detail: 'Full-time care beginning October 15',
              updated: 'Confirmed by the provider 14 minutes ago',
            }}
            onProfile={() => go('profile', { providerId: 'sunnyside' })}
            onPrimary={() => onBook('sunnyside', 'in-person')}
          />
          <ConceptProvider
            name="Morning Glory Co-op"
            address="811 S 8th Street, Philadelphia, PA"
            stars="4"
            ages="Toddler through school age"
            state={{
              kind: 'waitlist',
              title: 'Waitlist available',
              detail: 'No current openings for young toddlers',
              updated: 'Waitlist maintained by the provider',
            }}
            onProfile={() => go('profile', { providerId: 'morning-glory' })}
            onPrimary={() => onWaitlist('morning-glory', 'Young Toddler')}
          />
          <ConceptProvider
            name="Kiddie Academy of Fairmount"
            address="1901 Fairmount Avenue, Philadelphia, PA"
            stars="3"
            ages="Infant through school age"
            state={{
              kind: 'none',
              title: 'Live availability not provided',
              detail: 'Contact the provider for current openings',
            }}
          />
        </div>
      </div>
    </section>

    <section className="compass-separation">
      <div className="container">
        <div>
          <span>COMPASS / OCDEL</span>
          <h2>Official information remains official</h2>
          <p>Provider identity, licensing, Keystone STARS, programs, and inspection information.</p>
        </div>
        <Icon name="arrow-right" size={25}/>
        <div>
          <span>Find My Childcare</span>
          <h2>Providers add current family actions</h2>
          <p>Openings, freshness, tours, waitlists, photos, and provider-written updates.</p>
        </div>
      </div>
    </section>
  </div>
);
